import { Link } from "gatsby";
import { useState } from "react";
import styled from "styled-components";

import { Box, Heading, Stack } from "@vinomofo/components";

import { Button } from "../../button";
import { CollectionBanner, CollectionBannerProps } from "../collection-banner";

export interface FeaturedCollectionsProps {
  title?: string;
  collections: Array<CollectionBannerProps>;
}

const Navigation = styled(Box)`
  @media ${({ theme }) => theme.mq.min.desktop} {
    overflow-y: scroll;
    height: 390px;
  }
`;

export const FeaturedCollections = ({
  title = "Collections",
  collections,
}: FeaturedCollectionsProps): JSX.Element => {
  if (collections.length === 0) return null;

  const [activeCollection, setActiveCollection] = useState<
    CollectionBannerProps
  >(collections[0]);

  return (
    <CollectionBanner {...activeCollection}>
      <Stack space={[3, 5]}>
        <Heading as="h3" variant="lg" color="white">
          {title}
        </Heading>
        <Navigation>
          <Stack space={1}>
            {collections.map((collection, i) => {
              return (
                <Button
                  key={i}
                  onClick={() => setActiveCollection(collection)}
                  backgroundColor={
                    activeCollection === collection
                      ? collection.navigationColor
                      : "transparent"
                  }
                  color="white"
                  alignSelf="flex-start"
                >
                  {collection.navigationName}
                </Button>
              );
            })}
            <Button
              as={Box}
              to="/wines"
              backgroundColor="transparent"
              alignSelf="flex-start"
            >
              View all wines
            </Button>
          </Stack>
        </Navigation>
      </Stack>
    </CollectionBanner>
  );
};
